import {FC, ReactNode} from 'react'
import {cn} from '@utilities/helpers'

export interface RequiredActionCardProps {
    title: ReactNode
    description?: string
    icon: ReactNode
    cta: ReactNode
    variant?: 'fullBorder' | 'bottomBorder'
}
export const RequiredActionCard: FC<RequiredActionCardProps> = ({
    title,
    description,
    icon,
    cta,
    variant = 'fullBorder'
}) => {
    return (
        <div
            className={cn(
                'flex flex-col items-start justify-between gap-4 bg-white shrink-0 w-full max-w-[290px] md:max-w-full [&_p]:text-sm [&_p]:text-neutral-700',
                variant === 'fullBorder'
                    ? 'py-4 px-5 border border-neutral-300 rounded-xl'
                    : 'py-4 border-b border-neutral-300'
            )}
        >
            <div className="flex justify-between w-full items-center">
                <div className="flex flex-col gap-1">
                    {title}
                    {description && <p>{description}</p>}
                </div>
                {icon}
            </div>
            {cta}
        </div>
    )
}
